import React, { Component } from 'react';
import { Form, Badge } from 'react-bootstrap';
import MultiSelect from "react-multi-select-component";
import { MdOutlineFilterAlt } from "react-icons/md";
import { TfiAngleDown } from "react-icons/tfi";

class NewCampaignTemplateFilter extends Component {

    handleClearFilter = () => {
        if (this.props.handleClearFilter) {
            this.props.handleClearFilter(); // Call parent's clear filter handler
        } else {
            // Fallback if prop not provided
            this.props.handleLanguage([]);
            this.props.handleAttackType([]);
            this.props.handleCategory([]);
            this.props.handleLimit(12);
            this.props.handleStatus("");
        }
    }

    render() {
        const attackOptions = (this.props.attackTypes || []).map(at => ({ label: at.name, value: at.id }));
        const selectedAttack = Array.isArray(this.props.attackTypeId)
            ? attackOptions.filter(o => this.props.attackTypeId.includes(o.value))
            : (this.props.attackTypeId ? attackOptions.filter(o => o.value === this.props.attackTypeId) : []);
        return (
            <>

                <div className='filterFlex'>
                    <div className='filterActions'>
                        <div className='filterCount'>
                            <MdOutlineFilterAlt /> Filters(
                            {(() => {
                                const getLength = (value) => {
                                    if (!value) return 0;
                                    if (Array.isArray(value)) return value.length;
                                    return 1;
                                };

                                const total = getLength(this.props.languageId) +
                                    getLength(this.props.attackTypeId) +
                                    getLength(this.props.categoryId) +
                                    getLength(this.props.status);

                                return total > 0 ? total : 0;
                            })()}
                            )
                        </div>
                        <div className='clearFilter' onClick={this.handleClearFilter}>Clear Filter</div>
                    </div>
                    <div className="verticalFilters">

                        <Form.Group controlId="language" className="formGroup">
                            {(() => {
                                const languageOptions = (this.props.languages || []).map(lang => ({ label: lang.name, value: lang.id }));
                                const selectedLanguage = Array.isArray(this.props.languageId)
                                    ? languageOptions.filter(o => this.props.languageId.includes(o.value))
                                    : (this.props.languageId ? languageOptions.filter(o => o.value === this.props.languageId) : []);
                                return (
                                    <MultiSelect
                                        className="multi-select borderRemove"
                                        // clearSearch="Clear Search"
                                        options={languageOptions}
                                        value={selectedLanguage}
                                        ClearSelectedIcon={null}
                                        onChange={(selected) => {
                                            const ids = selected.map(s => s.value);
                                            this.props.handleLanguage(ids);
                                        }}
                                        ArrowRenderer={() => {
                                            return <>
                                                <TfiAngleDown className="down-arrow-campaign"></TfiAngleDown>
                                            </>
                                        }}
                                        valueRenderer={(selected) => {
                                            const count = selected.length;
                                            return count > 0 ? (
                                                <>Language <span className="filter-count">{count}</span> </>
                                            ) : 'Language';
                                        }}
                                        overrideStrings={{ selectSomeItems: 'Language' }}
                                    />
                                );
                            })()}
                        </Form.Group>

                        <Form.Group controlId="attacktype" className="formGroup">
                            <MultiSelect
                                className="multi-select borderRemove"
                                clearSearch="Clear Search"
                                options={attackOptions}
                                value={selectedAttack}
                                onChange={(selected) => {
                                    const ids = selected.map(s => s.value);
                                    this.props.handleAttackType(ids);
                                }}
                                ArrowRenderer={() => {
                                    return <>
                                        <TfiAngleDown className="down-arrow-campaign"></TfiAngleDown>
                                    </>
                                }}
                                valueRenderer={(selected) => {
                                    const count = selected.length;
                                    return count > 0 ? (
                                        <>Attack Vector <span className="filter-count">{count}</span> </>
                                    ) : 'Attack Vector';
                                }}
                                overrideStrings={{ selectSomeItems: "Attack Type" }}
                            />
                        </Form.Group>

                        <Form.Group className="formGroup">

                            <MultiSelect
                                className="multi-select borderRemove"
                                clearSearch="Clear Search"
                                options={this.props.categories}
                                value={this.props.categoryId}
                                onChange={this.props.handleCategory}
                                ArrowRenderer={() => {
                                    return <>
                                        <TfiAngleDown className="down-arrow-campaign"></TfiAngleDown>
                                    </>
                                }}
                                valueRenderer={(selected) => {
                                    const count = selected.length;
                                    return count > 0 ? (
                                        <>Categories <span className="filter-count">{count}</span> </>
                                    ) : 'Categories';
                                }}
                                overrideStrings={{ selectSomeItems: "Categories" }}
                            />
                        </Form.Group>

                        {this.props.type === "My Templates" && (
                            <Form.Group controlId="exampleForm.ControlSelect1" className="formGroup">
                                <div className="position-relative-status">
                                    <Form.Control
                                        as="select"
                                        value={""}
                                        onChange={e => this.props.handleStatus(e.target.value)}
                                         className="custom-select-arrow"
                                    >
                                        <option value="" disabled>Status</option>
                                        <option value="all" >All</option>
                                        <option value="draft">Draft</option>
                                        <option value="completed">Completed</option>
                                    </Form.Control>
                                    {this.props.status !== "all" && (() => {
                                        const statusLabels = {
                                            "draft": "Draft",
                                            "completed": "Completed"
                                        };
                                        return (
                                            <Badge
                                                variant={"primary"}
                                            >
                                                {statusLabels[this.props.status] || this.props.status}
                                            </Badge>
                                        );
                                    })()}
                                    {/* <TfiAngleDown className="down-arrow-campaign select-arrow-icon" /> */}
                                </div>
                            </Form.Group>
                        )
                        }
                        
                    </div >
                </div >

            </>





        );
    }
}

export default NewCampaignTemplateFilter;
